// extracted by mini-css-extract-plugin
export default {"Chevron":"Chevron_Chevron__D3HIn","swing-in":"Chevron_swing-in__x7sZf"};